import { render, staticRenderFns } from "./BtnInserirDespesaParceiro.vue?vue&type=template&id=7dc8189c"
import script from "./BtnInserirDespesaParceiro.vue?vue&type=script&lang=js"
export * from "./BtnInserirDespesaParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports